// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9c0230a1","144":"a966a9cf","151":"27a884eb","197":"27a884eb","440":"72337f82","650":"e81c57d8","706":"de5ecc0a","708":"6a0af409","743":"72337f82","813":"513fdec8","936":"a966a9cf","948":"27a884eb"}[chunkId] + ".chunk.css";
};